import {DELETE_GROUP_CYCLE_ERROR, DELETE_GROUP_CYCLE_START, DELETE_GROUP_CYCLE_SUCCESS} from "../../types";

export default function delete_group_cycle(state, action) {
    switch (action.type) {
        case DELETE_GROUP_CYCLE_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_GROUP_CYCLE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case DELETE_GROUP_CYCLE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
